import styled from 'styled-components';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from '@mui/material';
import { SpinnerLoading } from '../styles';

export const AccordionHistoryStyle = styled(Accordion)`
  background: ${({ theme }) => theme.grayLight} !important;
  padding: 0.6rem 0 !important;
  margin: 0 0 1rem !important;

  /* When is Expanded */
  &.MuiAccordion-root.Mui-expanded {
    margin: 0 0 1rem !important;
  }
  &&&{
    .MuiAccordionSummary-expandIconWrapper .MuiSvgIcon-root {
      color: ${({ theme }) => theme.pantone2727C} !important;
    }
    .MuiAccordionSummary-content {
      background: transparent !important;
    }
  }
`;
export const AccordionSummaryHistory = styled(AccordionSummary)`
  background: ${({ theme }) => theme.grayLight} !important;
  padding: 0 16px !important;
`;
export const AccordionTitle = styled.h5`
  font-weight: bold !important;
  margin: 0 !important;
  color: ${({ theme }) => theme.pantoneBlack} !important;
`;

export const AccordionDetailsHistory = styled(AccordionDetails)`
  display: flex !important;
  flex-direction: column !important;
  background: ${({ theme }) => theme.grayLight} !important;
  padding: 0 8px !important;

  ${SpinnerLoading} {
    margin: 0.4rem auto !important;
  }
`;

